<template>
	<div class="home_page">
		<div class="home_wrap" id="home_wrap" v-if="home_show == 1 && show_page">
			<!-- 标头 -->
			<div class="red_top_bg" id="red_top_bg">
				<div class="logo">
					<!-- <img src="../img/index/logo2.png"> -->
					<!-- <img src="../img/user/usdt.png" />  -->
					<img :src="logo"> {{ $t('数字加密货币银行') }} 
					
				</div>
				<div style="flex: 1;"></div>
				<div class="language" @click="$router.push('/language')">
					<img :src="language_logo">
					<!-- <div>{{ country_loc }}</div> -->
				</div>
				
				<img class="outlog" v-if="token"  @click="logout" src="../img/index/outlog.png" />
			</div>
			<!-- 轮播图 -->
			<div class="swiper_container">
				<van-swipe v-show="loading" :autoplay="2500" class="swiper-container">
					<van-swipe-item v-for="(image, index) in banners" :key="index" @click='jump(image)'>
						<!-- <img :src="require('../img'+image.img)"> -->
						<img :src="image.img">
					</van-swipe-item>
				</van-swipe>
				
				<div class="Vip_name">{{ Vip_name }}</div>
			</div> 
			<!-- 滚动消息 -->
			<div class="block_div notice" @click="$router.push('/notice')">
				<van-notice-bar background="#FFFFFF" color="#000000" left-icon="volume-o" :text="notice?.title || ''" />
			</div>
			<!-- 快捷菜单 -->
			<div class="block_div  work_box">
				<!-- <div class="flex_center">
					<div v-for="(item, index) in menus" class="item" @click='jump(item.url)'>
						<div class="item_img"><img :src="require('../img/' + item.logo)" alt=""></div>
						<p class="item_title">{{ item.title }}</p>
					</div>
				</div> -->
				<div class="flex_center">
					<div v-for="(item, index) in menus2" class="item" @click='jump(item)'>
						<div class="item_img"><img :src="require('../img/' + item.logo)" alt=""></div>
						<p class="item_title">{{ item.title }}</p>
					</div>
				</div>
			</div>



				<div class="currency_tips">
					{{ $t('我的账户') }}
				</div>


				<div class="block_div  work_box flex_center">
					<div class="einkommen">
						<div class="einkommen_txt">{{ $t('账户') }}(USDT)</div>
						<div class="einkommen_num">
							<mDigitalFlop :numberFixed="3" ref="mDigitalFlop1"></mDigitalFlop>
						</div>

					</div>
					<div class="einkommen">
						<div class="einkommen_txt">{{ $t('总收入') }}(USDT)</div>
						<div class="einkommen_num">
							<mDigitalFlop :numberFixed="3" ref="mDigitalFlop2"></mDigitalFlop>
						</div>
					</div>
					<div class="einkommen">
						<div class="einkommen_txt">{{ $t('今日收益') }}(USDT)</div>
						<div class="einkommen_num">
							<mDigitalFlop :numberFixed="3" ref="mDigitalFlop3"></mDigitalFlop>
						</div>
					</div>
					<div class="einkommen">
						<div class="einkommen_txt">{{ $t('财务收益') }}(USDT)</div>
						<div class="einkommen_num">
							<mDigitalFlop :numberFixed="3" ref="mDigitalFlop4"></mDigitalFlop>
						</div>
					</div>
				</div>
			<div class="currency_tips">
				{{ $t('用户池') }}
			</div>

			<div class="block_div  work_box flex_center">
				<div class="einkommen">
					<div class="einkommen_txt">{{ $t('总产生量') }}(USDT)</div>
					<div class="einkommen_num">
						<mDigitalFlop ref="mDigitalFlop5"></mDigitalFlop>
					</div>

				</div>
				<div class="einkommen">
					<div class="einkommen_txt">{{ $t('有效节点') }}</div>
					<div class="einkommen_num">
						<mDigitalFlop ref="mDigitalFlop6"></mDigitalFlop>
					</div>
				</div>
				<div class="einkommen">
					<div class="einkommen_txt">{{ $t('参加人数') }}</div>
					<div class="einkommen_num">
						<mDigitalFlop ref="mDigitalFlop7"></mDigitalFlop>
					</div>

				</div>
				<div class="einkommen">
					<div class="einkommen_txt">{{ $t('收益') }}(USDT)</div>
					<div class="einkommen_num">
						<mDigitalFlop ref="mDigitalFlop8"></mDigitalFlop>
					</div>
				</div>
			</div>

			<!-- 货币价格 -->
			<!-- <div class="currency_tips">
				{{ $t('index.exchangeRate') }}
			</div>
			<div class="block_div currency_wrap">
				<van-swipe style="height: 70px;" :autoplay="2000" vertical :show-indicators="false">
					<van-swipe-item v-for="(lang, index) in langs" :key="index" @click="$router.push('/currency')">
						<div class="currency_detail">
							<div class="flex_center currency">
								<div class="flex_center logo">
									<img :src="lang.logo" alt="">
									<p>{{ lang.symbol }}</p>
								</div>
								<div class="price">
									<div>
										<span>1 USD</span>
										<span> ≈ {{ lang.price }} {{ lang.symbol }}</span>
									</div>
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div> -->

			<!-- 项目列表 -->
			<!-- <div class="currency_tips">
				{{ $t('index.recommendedItem') }}
			</div>
			<div class="items">
				<div class="block_div item" v-if="tax.show" @click="$router.push('/invest/detail_tax')">
					<div class="logo">
						<img v-lazy="tax.img" />
						<div>{{ tax.title }}</div>
					</div>
					<div class="flex_center tax_detail">
						<div class="tax_price">
							<span>{{ $t('invest.taxMoney') }}</span>
							<span class="color999">{{ common.currency_symbol_basic() }}{{ common.precision_basic(tax.money)
							}}</span>
						</div>
						<div class="tax_btn">
							{{ $t('invest.taxPay') }}
						</div>
					</div>
				</div>
				<div v-for="(item, index) in items" class="block_div item"
					@click="$router.push('/invest/detail/' + item.id)">
					<div class="logo">
						<img v-lazy="item.img2" />
						<div>{{ item.title }}</div>
					</div>
					<div class="titledesc" style="color: red; font-size: 12px; margin-top: 10px; padding: 0 10px;">{{
						item.titledesc }}</div>
					<div class="flex_center detail">
						<div>
							<div><span class="detail_name">{{ $t('index.amount') }}</span><span class="detail_num">{{
								item.type2 == 1 ? common.currency_symbol_basic() : "" }}{{
		common.precision_basic(item.min) }}{{ item.type2 == 2 ? "TRX" : "" }}</span>
							</div>
							<div><span class="detail_name">{{ $t('index.cycle') }}</span><span class="detail_num">{{
								item.day }}{{ item.type == 3 ? $t('index.hour') : $t('index.day') }}</span>
							</div>
						</div>
						<div>
							<div><span class="detail_name">{{ item.type == 1 ? $t('index.dailyRate') : $t('index.rate')
							}}</span><span class="detail_num">{{ item.rate }}%</span></div>
							<div><span class="detail_name">{{ $t('invest.income') }}</span><span class="detail_num">{{
								item.type2 == 1 ? common.currency_symbol_basic() : "" }}{{
		common.precision_basic(change(item)) }}{{ item.type2 == 2 ? "TRX" : "" }}</span>
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<!-- APP -->
			<!-- <div v-if="!isApp && app.show" id="download_app" class="flex_center">
				<div class="flex_center">
					<div class="app_close" @click="closeDown()">
						X
					</div>
					<div class="app_logo">
						<img :src="app.logo" alt="" srcset="">
					</div>
					<div class="app_name">
						<p>{{ app.name }}</p>
					</div>
				</div>
				<div class="basic_btn down_btn" @click="jump(app.url)">
					{{ $t('index.downApp') }}
				</div>
			</div> -->
			<!-- 弹窗 -->
			<van-dialog v-model="show_tc" :confirmButtonText="$t('utils.confirm')">
				<div class="popup" v-html="tc_content"></div>
			</van-dialog>
			<!-- 客服图标 -->
			<!-- <div class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
				<img class="kefu_img" src="../img/index/kefu.png">
			</div> -->
		</div>
		<div class="home_wrap" id="home_wrap" v-if="home_show == 0 && show_page">
			<!-- 轮播图 -->
			<div class="swiper_container">
				<van-swipe v-show="loading" :autoplay="2500" class="swiper-container">
					<van-swipe-item v-for="(image, index) in banners" :key="index" @click='jump(image)'>
						<!-- <img :src="require('../img'+image.img)"> -->
						<img :src="image.img">
					</van-swipe-item>
				</van-swipe>
			</div>
			<!-- 滚动消息 -->
			<div class="block_div notice" @click="$router.push('/notice')">
				<van-notice-bar background="#FFFFFF" color="#000000" left-icon="volume-o" :text="notice?.title || ''" />
			</div>
			<!-- 快捷菜单 -->
			<div class="block_div  work_box">
				<div class="flex_center">
					<div v-for="(item, index) in menus3" class="item" @click='jump(item)'>
						<div class="item_img"><img :src="require('../img/' + item.logo)" alt=""></div>
						<p class="item_title">{{ item.title }}</p>
					</div>
				</div>

			</div>

			<!-- 签到功能 -->
			<div class="sign_box">
				<div class="sign_list">
					<div class="item_sign" v-for="(item, index) in pointdata" :key="index">
						<!-- 可获取分数 -->
						<div class="point">
							<div class="yes_sign_box" v-if="Number(days) == index + 1 || Number(days) > index + 1">
								<img class="kefu_ico" src="../img/index/index_duihao.png" alt="">
								<div class="sign_point_num">{{ item.point }}</div>
							</div>
							<div class="no_sign_box" v-else>
								<img class="kefu_ico" src="../img/index/sing_fudai.png" alt="">
								<div class="sign_point_num">{{ item.point }}</div>
							</div>


							<div class="sign_num">
								{{ item.total }} {{ $t('次') }}
							</div>
						</div>
					</div>
				</div>

				<!-- 签到按钮 -->
				<div class="sign_btn" @click="newsignin()">
					{{ $t('签到') }}
				</div>
			</div>

			<!-- 热门兑换 -->
			<div class="product_list_box">

				<div class="header_title">{{ $t('热门兑换') }}</div>
				<div class="product_list">
					<div class="item_product" v-for="(item, index) in list" :key="index"
						@click="$router.push('/goods/detail/' + item.id)">
						<div class="pro_info">
							<img class="pro_logo" :src="item.img" alt="">
							<div class="detail_box">
								<div class="pro_title">{{ item.title }}<span class="hot_box">Hot</span></div>
								<div class="pro_point">{{ item.point }}{{ $t('goods.point') }}<span class="ydh">{{
									$t('已兑换')
								}} {{ item.exchange_total }} {{ $t('次') }}</span></div>
							</div>
						</div>
						<!-- 兑换 -->
						<div class="duihuan_box">
							<div class="duihuan_btn">
								{{ $t('兑换') }}
							</div>
						</div>
					</div>
				</div>
			</div>




			<!-- APP -->
			<!-- <div v-if="!isApp && app.show" id="download_app" class="flex_center">
				<div class="flex_center">
					<div class="app_close" @click="closeDown()">
						X
					</div>
					<div class="app_logo">
						<img :src="app.logo" alt="" srcset="">
					</div>
					<div class="app_name">
						<p>{{ app.name }}</p>
					</div>
				</div>
				<div class="basic_btn down_btn" @click="jump(app.url)">
					{{ $t('index.downApp') }}
				</div>
			</div> -->
			<!-- 弹窗 -->
			<van-dialog v-model="show_tc" :confirmButtonText="$t('utils.confirm')">
				<div class="popup" v-html="tc_content"></div>
			</van-dialog>
			<!-- 客服图标 -->
			<!-- <div class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
				<img class="kefu_img" src="../img/index/kefu.png">
			</div> -->
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import mDigitalFlop from '@/components/mDigitalFlop'
import Api from "../../interface/index"
import axios from 'axios'
import {
	Swipe,
	SwipeItem,
	Progress,
	Dialog,
	Field,
	Popup,
	NoticeBar,
	Lazyload,
	Search
} from "vant";

Vue.use(Progress).use(Dialog).use(Field).use(Popup).use(NoticeBar).use(Lazyload).use(Search);

export default {
	name: "Index",
	components: {
		mDigitalFlop,
		VanSwipe: Swipe,
		VanSwipeItem: SwipeItem,
	},
	data() {
		return {
			language_logo: localStorage.getItem('language_logo'),
			logo: localStorage.getItem("logo2"),
			country_loc: localStorage.getItem("country_loc") ? localStorage.getItem("country_loc") : 'English',
			token: localStorage.getItem('token'),
			menus: [
				// 	{
				// 	"title": this.$t('user.recharge'),
				// 	"logo": "index/receive.png",
				// 	"url": "/user"
				// },
				// {
				// 	"title": this.$t('user.withdraw'),
				// 	"logo": "index/send.png",
				// 	"url": "/user"
				// },
				// {
				// 	"title": this.$t('user.signin'),
				// 	"logo": "user/signin2.png",
				// 	"url": "/qiandao"
				// },

				// {
				// 	"title": this.$t('user.luckyDraw'),
				// 	"logo": "index/luckyDraw.png",
				// 	"url": "/draw"
				// },

				{
					"title": this.$t('savings.savings'),
					"logo": "index/savings1.png",
					"url": "/savings"
				}
			],
			menus3: [{
				"title": this.$t('user.signin'),
				"logo": "user/signin2.png",
				"url": "/qiandao"
			},

			{
				"title": this.$t('user.luckyDraw'),
				"logo": "index/luckyDraw.png",
				"url": "/draw"
			},
			{
				"title": this.$t('invite.invite'),
				"logo": "user/invite.png",
				"url": "/invite"
			},
			{
				"title": this.$t('goods.goods'),
				"logo": "index/goods.png",
				"url": "/goods"
			},
			],
			menus2: [
				// {
				// 	"title": this.$t('goods.goods'),
				// 	"logo": "index/goods.png",
				// 	"url": "/goods"
				// },
				// {
				// 	"title": this.$t('savings.savings'),
				// 	"logo": "index/savings1.png",
				// 	"url": "/wallet"
				// },
				{
					"title": this.$t('user.rewards'),
					"logo": "index/question1.png",
					"url": "/rewards"
				},
				{
					"title": this.$t('user.withdraw'),
					"logo": "index/send.png",
					"url": "/withdraw",
					click: () => {


						Fetch('/user/getWithdrawalMethod').then(r => {
							// this.withdrawMethod = r.data.withdrawMethod;
							// this.wallets = r.data.wallets;
							if (r.data.wallets.length > 0) {

								this.$router.push('/withdraw');
							} else {
								this.$router.push('/wallet/bank/' + r.data.withdrawMethod[0].id)
							}
						})
					}
				},
				{
					"title": this.$t('user.onlineService'),
					"logo": "user/kf.png",
					"url": "/service"
				}
			],
			show_kefu: false,
			loading: false,
			notice: [],
			show_tc: false,
			tc_content: "",
			banners: [],
			items: [],
			langs: [],
			isApp: true,
			app: {
				"show": false,
				"name": "",
				"url": "",
				"logo": "",
			},
			value: '',
			tax: {
				show: false
			},
			signinStatue: false,
			list: [],

			user: {
				login: false,
				point: 0,
			},
			pointdata: [],
			days: "2",
			home_show: 0,
			show_page: false,
			virtual_data: {
				virtual_alltotal: 0,
				virtual_income: 0,
				virtual_node: 0,
				virtual_people: 0
			},
			startTime:null,
			Vip_name:''
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#FFFFFF');
			plus.navigator.setStatusBarStyle('dark');
		}
		this.$parent.footer('index');

	},
	mounted() {
		this.start();
		this.startTime =  setInterval(() => {
			this.start();
		}, 180000);
		var that = this;
		document.body.addEventListener("scroll", function () {
			if (!that.show_kefu) {
				return;
			}
			that.show_kefu = false;
		}, false);
		document.addEventListener('click', function (ev) {
			if (ev.target.className != 'kefu_img') {
				that.show_kefu = false;
			}
		}, false);
	},
	unmounted() {
		clearInterval(this.startTime)
	},
	methods: {
		newsignin() {
			var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			Fetch('/user/info', {
				isapp: isapp
			}).then((r) => {
				this.signinStatue = r.data.signin;
				this.newIsSign();
			});
		},
		newIsSign() {
			let that = this;
			if (this.signinStatue) {
				this.$toast(this.$t('user.signined'));
				// setTimeout(function () {
				// 	that.$router.push('/goods');
				// }, 3000);
				return;
			}
			this.signinStatue = true;

			Fetch('/user/signin').then((r) => {
				this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
				this.start();
			});
		},
		signin() {

			var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			Fetch('/user/info', {
				isapp: isapp
			}).then((r) => {
				this.signinStatue = r.data.signin;
				this.isSign();
			});

		},

		isSign() {
			let that = this;
			if (this.signinStatue) {
				this.$toast(this.$t('user.signined'));
				setTimeout(function () {
					that.$router.push('/goods');
				}, 3000);
				return;
			}
			this.signinStatue = true;

			Fetch('/user/signin').then((r) => {
				this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
				setTimeout(function () {
					that.$router.push('/goods');
				}, 3000);
			});
		},
		change(item) {
			if (item.type == 1) {
				return this.common.precision_basic(item.min * item.rate * item.day / 100);
			} else {
				return this.common.precision_basic(item.min * item.rate / 100);
			}
		},
		kefu_to() {
			if (this.show_kefu) {
				this.$router.push('/service');
			}
			this.show_kefu = !this.show_kefu;
		},
		jump(item) {
			if(!this.token){
				
			return this.$router.push("/login");
			}
			if (item.click) {
				return item.click()
			}
			if (item.url == '/qiandao') {
				// this.signin();
				this.$router.push('/sign');

			} else {
				if (item.url.indexOf('http') == 0) {
					// console.log('http');
					window.location.href = item.url;
				} else {
					this.$router.push(item.url);
				}
			}

		},
		start() {
			
			if(this.token){

				var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			Fetch('/user/info', {
				isapp: isapp
			}).then((r) => {
				this.Vip_name = r.data.vip_name
			});
			}
			Fetch('/index/int').then((r) => {
				block: {
					if (r.data.popup.show == 1) {
						var popup_show = sessionStorage.getItem("popup_show");
						sessionStorage.setItem("popup_show", r.data.popup.num);
						if (popup_show != null && popup_show == 1) {
							break block;
						}
						this.tc_content = r.data.popup.content;
						// this.show_tc = true;
					}
				}
				// console.log("banner",r.data.banner);
				this.banners = r.data.banner;
				// this.banners=[{img: "/index/banner1.png"},{img: "/index/banner2.png"}];
				this.notice = r.data.notice;
				this.langs = r.data.langs;
				this.items = r.data.items;
				this.tax = r.data.tax;
				this.pointdata = r.data.pointdata;
				this.loading = true;
				this.app = r.data.version;
				this.home_show = r.data.home_show;
				this.days = r.data.sign_total;
				this.show_page = true;

				const virtual_data = r.data.virtual_data

				if(this.token){
					const userinfo = r.data.userinfo
					this.$nextTick(() => {
						this.$refs.mDigitalFlop1.update(Number(userinfo.money))
						this.$refs.mDigitalFlop2.update(Number(userinfo.incomeall))
						this.$refs.mDigitalFlop3.update(Number(userinfo.today_income))
						this.$refs.mDigitalFlop4.update(Number(userinfo.income))
					})
				}
				this.$nextTick(() => {
					this.$refs.mDigitalFlop5.update(virtual_data.virtual_alltotal)
					this.$refs.mDigitalFlop6.update(virtual_data.virtual_node)
					this.$refs.mDigitalFlop7.update(virtual_data.virtual_people)
					this.$refs.mDigitalFlop8.update(virtual_data.virtual_income)
				})

				// this.showApp();
			});

			Fetch('/index/goods_list', {
				page: 1,
				listRows: 10000
			}).then(r => {
				this.user = r.data.user;
				var list = r.data.list;
				for (var i = 0; i < list.length; i++) {
					this.list.push(list[i]);
				}


			});
		},
		showApp() {
			if (window.plus) {
				this.isApp = true;
			} else {
				if (this.app.show) {
					this.isApp = false;
					document.getElementById('red_top_bg').style.top = '60px';
					document.getElementById('home_wrap').style.paddingTop = '60px';
				}
			}
		},
		closeDown(url) {
			this.app.show = false;
			document.getElementById('red_top_bg').style.top = '0';
			document.getElementById('home_wrap').style.paddingTop = '0';
		},
		logout() {
			localStorage.removeItem('token');
			this.$router.push("/login");
		}
	}
};
</script>

<style lang="less" scoped>
.home_wrap {
	margin-bottom: 60px;
}

.product_list_box {
	padding: 20px 16px;
	background-color: #FFFFFF;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);
	display: flex;
	flex-direction: column;

	.header_title {
		font-size: 15px;
		color: black;
		font-weight: 600;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 15px;
	}

	.product_list {
		.item_product {
			display: flex;
			justify-content: space-between;
			padding: 20px 0;
			border-bottom: 1px solid rgba(185, 174, 174, 0.3);

			.pro_info {
				display: flex;
				justify-content: left;



				.pro_logo {
					width: 80px;
					height: 80px;
				}

				.detail_box {
					display: flex;
					flex-direction: column;
					margin-left: 10px;
					flex: 1;

					.pro_title {
						font-size: 14px;
						line-height: 20px;
						color: black;
						font-weight: 500;

						.hot_box {
							padding: 1px 6px;
							border: 1px solid red;
							border-radius: 25px;
							font-size: 10px;
							color: red;
							margin-left: 5px;

						}
					}

					.pro_point {
						font-size: 14px;
						color: #FFA500;
						font-weight: 500;
						margin-top: auto;

						.ydh {
							font-size: 12px;
							margin-left: 5px;
							color: #817d78;
						}
					}


				}
			}

			.duihuan_box {
				min-width: 120px;
				display: flex;
				align-items: center;
				justify-content: right;

				.duihuan_btn {
					padding: 5px 16px;
					border-radius: 50px;
					display: flex;
					align-items: center;
					justify-content: center;
					background: rgba(173, 216, 230, 0.5);
					color: #0F6EFF;
					font-size: 13px;
					display: inline-block;
				}

			}
		}
	}
}

.sign_box {
	padding: 20px 16px;
	margin-bottom: 15px;
	background-color: #FFFFFF;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);

	.sign_list {
		width: 100%;
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
		margin: 0 auto;

		.item_sign {
			width: calc((100% - 40px) / 5);

			.point {

				.no_sign_box {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					width: 100%;
					padding: 10px 0;
					background-color: rgba(0, 0, 0, 0.05);
					border-radius: 8px;

					.sign_point_num {
						color: black;
						margin-top: 10px;
					}

					.kefu_ico {
						width: 35px;
					}

				}

				.yes_sign_box {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					width: 100%;
					padding: 10px 0;
					background-color: rgba(173, 216, 230, 0.5);
					border-radius: 8px;

					.sign_point_num {
						color: #3775F4;
						margin-top: 10px;
					}

					.kefu_ico {
						width: 35px;
					}

				}

				.sign_num {
					text-align: center;
					color: #cebcbc;
					margin-top: 15px;
				}

			}
		}
	}

	.sign_btn {
		width: 200px;
		padding: 10px 0px;
		color: #fff;
		background: #3775F4;
		border-radius: 16px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
	}

}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
	height: 68px;
	padding: 10px 0;
	background: #1a1c2d;
	display: flex;
	align-items: center;
	padding: 0 15px;

	.logo {
		// position: absolute;
		// top: 10px;
		// left: 3%;
		height: 48px;
		line-height: 48px;
		font-size:16px;
		color: #3de7c9;
		display: flex;
		align-items: center;

		img {
			height: 100%;
			// border-radius: 50%;
			margin-right: 10px;
		}
	}

	.language {
		// position: absolute;
		top: 16px;
		right: 3%;
		height: 36px;
		display: flex;
		align-items: center;
		flex-direction: column;
		color: #ffffff;

		img {
			height: 100%;
		}
	}
}

.swiper_container {
	// min-height: 182px;
	position: relative;
	// background: #FFFFFF;
}

.block_div {
	background: none;
	box-shadow: 0 0 8px 0px #3b3f5f;
	color: #ffffff;
	margin: 20px auto;
}

.swiper-container {
	width: 100%;
	margin: 80px 0 0 0;


	.van-swipe-item {
		overflow: hidden;
	}

	img {
		border-radius: 5px;
		margin-left: 3%;
		height: 100%;
		width: 94%;
	}
}


.notice {
	margin-bottom: 10px;
}

.work_box {
	padding: 10px 0 0 0;
	// max-height: 160px;
	margin-bottom: 15px;
	flex-wrap: wrap;

	.item {
		// width: 33.33%;
		width: 50%;
		text-align: center;
		margin-bottom: 10px;

		.item_img {
			width: 100%;
			border-radius: 5px;
			overflow: hidden;

			img {
				width: 44px;
				height: 44px;
				padding: 4px;
			}
		}

		.item_title {
			width: 100%;
			line-height: 14px;
			font-size: 12px;
			color: #ffffff;
			text-align: center;
			transform: scale(0.85);
		}
	}
}

.currency_wrap {
	margin-bottom: 15px;

	img {
		width: 40px;
	}

	.currency_detail {
		padding: 20px 0;
	}

	.currency {
		justify-content: space-around;

		p {
			font-size: 14px;
			font-weight: bold;
		}

		.logo {
			p {
				margin-left: 5px;
			}
		}

		.price {
			color: #3CB371;
			font-weight: bold;
		}
	}
}

.popup {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	flex: 1;
	max-height: 60vh;
	padding: 26px 24px;
	overflow-y: auto;
	font-size: 14px;
	line-height: 20px;
}

.currency_tips {
	margin-bottom: 10px;
	margin-left: 3%;
	border-left: 5px solid #3de7c9;
	padding-left: 10px;
	font-size: 14px;
	color: #ffffff;
	font-weight: bold;
}

.items {
	margin-bottom: 20px;

	.item {
		margin-bottom: 10px;


		.logo {
			position: relative;

			div {
				position: absolute;
				bottom: 0px;
				width: 100%;
				background: #FFFFFF;
				height: 30px;
				line-height: 30px;
				opacity: 0.8;
				font-weight: bold;
				padding: 0 10px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			img {
				width: 100%;
				border-radius: 5px;
				max-height: 260px;
			}
		}

		.detail {
			padding: 15px;
			line-height: 2;

			.detail_name {}

			.detail_num {
				font-weight: bold;
				color: #3CB371;
			}
		}

		.tax_detail {
			background: #ff0000;
			color: #fff;
			padding: 20px 10px;
			border-radius: 0 0 5px 5px;

			.color999 {
				color: #e1e1e1;
			}
		}
	}
}

#download_app {
	position: fixed;
	background: #fff;
	width: 100%;
	max-width: 750px;
	top: 0;
	height: 60px;
	z-index: 11;
	justify-content: space-between;
	box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
	padding: 0 20px 0 0;

	.app_close {
		color: #999;
		width: 50px;
		line-height: 60px;
		height: 60px;
		text-align: center;
	}

	.app_logo {
		margin-right: 5px;

		img {
			height: 30px;
		}
	}

	.down_btn {
		padding: 0 5px;
		width: unset;
		height: 32px;
		line-height: 32px;
		font-size: 14px;
	}
}

/deep/.van-notice-bar {
	border-radius: 0 0 5px 5px;
}

.van-icon {
	color: #ed6a0c;
}

.einkommen {
	text-align: center;
	font-size: 16px;
	padding: 6px 10px;
	width: 50%;
}

.einkommen_num {
	font-weight: bold;
	// padding-bottom: 10px;
}

.einkommen_txt {
	margin-bottom: 4px;
	font-size: 14px;
	white-space: nowrap;
	// height: 2em;
}
.outlog{
	width: 26px;
	margin-left: 10px;
}
.Vip_name{
	position: absolute;
	bottom: 10px;
	font-size: 14px;
	color: #ffffff;
	right: 20px;
	// background: #65c571;
	padding: 10px 15px;
	border-radius: 50px;
}
</style>
